import { Exchange, makeOperation, mapExchange } from '@urql/core'
import { buildClientSchema } from 'graphql'
import { getOperationName } from '../../utils'
import { visitAndCollectListTypenames } from './visitAndCollectListTypenames'

type Args = {
  // graphql-jsのschemaの型が実態と異なるため、any型を使用している
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  introspection: any
  debug?: boolean
}

export const additionalTypenamesExchange = ({ introspection, debug = false }: Args): Exchange => {
  // イントロスペクションスキーマを元にクライアントスキーマを構築
  const clientSchema = buildClientSchema(introspection)

  return mapExchange({
    onOperation: operation => {
      const { query } = operation
      // 重複を排除するためにSetオブジェクトを使用する
      // 初期値には事前に指定されているadditionalTypenamesを設定する
      const additionalTypenamesSet = new Set(operation.context.additionalTypenames)

      // スキーマからクエリの型を取得
      const queryType = clientSchema.getQueryType()

      // スキーマにクエリ型が存在する場合のみqueryからadditionalTypenamesに追加すべき型名を取得する
      if (queryType) {
        // クエリを再帰的に訪問してリスト型のオブジェクト名を収集する
        visitAndCollectListTypenames(query, queryType, additionalTypenamesSet, clientSchema)
      }

      // Setオブジェクトを配列に変換
      const additionalTypenames = Array.from(additionalTypenamesSet)

      // デバッグモードの場合はログを出力する
      if (debug) {
        console.log(
          '[DEBUG] additionalTypenamesExchange:',
          JSON.stringify(
            {
              operationName: getOperationName(operation),
              additionalTypenames,
            },
            null,
            2,
          ),
        )
      }

      // additionalTypenamesを追加したoperationを返す
      return makeOperation(operation.kind, operation, {
        ...operation.context,
        additionalTypenames,
      })
    },
  })
}
